module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/cuneo.52b8c7252503b656d3e088cc30d63266.jpg";